import type { ReactNode } from 'react';
import { ActionBar } from './ActionBar';

type AvatarSize = 22 | 26 | 32 | 56;

/** Аватар `.ava` с инициалами — только на строках о людях и объектах (кит 2.13). */
export function Avatar({ initials, size }: { initials: string; size: AvatarSize }) {
  return <span className={`ava ava-${size}`}>{initials}</span>;
}

/**
 * Шапка объекта `.phead` (кит v2.0): аватар 56, заголовок с плашками,
 * строка мета, справа главная кнопка и «⋯». На телефоне кит прячет
 * `.acts`, и те же действия встают в нижнюю панель `.abar` — экрану
 * нужен `.main.has-abar`.
 */
export function PersonHeader({
  initials,
  title,
  pills,
  meta,
  actions,
}: {
  initials: string;
  title: string;
  pills?: ReactNode;
  meta?: ReactNode;
  actions?: ReactNode;
}) {
  return (
    <>
      <div className="phead">
        <Avatar initials={initials} size={56} />
        <div className="who">
          <div className="nmr">
            <h1 className="h1">{title}</h1>
            {pills}
          </div>
          {meta ? <div className="meta">{meta}</div> : null}
        </div>
        <div className="acts">{actions}</div>
      </div>
      {actions ? <ActionBar>{actions}</ActionBar> : null}
    </>
  );
}

/** Строка связи `.lrow` (кит v2.0): аватар, имя, подпись, действия, шеврон. */
export function LinkRow({
  initials,
  name,
  sub,
  value,
  onClick,
}: {
  initials: string;
  name: ReactNode;
  sub?: ReactNode;
  value?: ReactNode;
  onClick?: () => void;
}) {
  return (
    <div className="lrow" onClick={onClick} role={onClick ? 'link' : undefined}>
      <Avatar initials={initials} size={26} />
      <div className="x">
        <div className="n">{name}</div>
        {sub ? <div className="s">{sub}</div> : null}
      </div>
      <div className="v">{value}</div>
      <span className="chev">›</span>
    </div>
  );
}

/** Строка «кто» в таблице: аватар 32 и имя с подписью (стиль модуля M2 `.cwho`). */
export function Who({ initials, name, sub }: { initials: string; name: ReactNode; sub?: ReactNode }) {
  return (
    <div className="cwho">
      <Avatar initials={initials} size={32} />
      <div className="x">
        <span className="nm">{name}</span>
        {sub}
      </div>
    </div>
  );
}
